export default __webpack_public_path__ + "static/media/smeta.09a0e8c4.svg";